import BordPhoto from 'components/NudosComponents/BordPhoto/BordPhoto';
import './UserWhoCancelledOrder.scss';
const UserWhoCancelledOrder = ({ userWhoCancelledOrder }: IUserWhoCancelledOrderProps) => {
  return (
    <div className="userWhoCancelledOrder">
      <div className="userWhoCancelledOrderPhoto">
        <BordPhoto
          url={userWhoCancelledOrder?.profilePhoto || ''}
          size="s24"
          variant="circle"
          avatarProps={{ variant: 'circularUser' }}
        />
      </div>
      <span className="userWhoCancelledOrderName">{userWhoCancelledOrder?.name}</span>
    </div>
  );
};

interface IUserWhoCancelledOrderProps {
  userWhoCancelledOrder: {
    name: string;
    profilePhoto: string;
  };
}
export default UserWhoCancelledOrder;
